const configBoardFilter = {
    homenews: {
        getFunc: 'getMainNews',
        listApiParamSet: {
            nof: 'NoticeFile',
        },

    },
    homedonate: {
        getFunc: 'getMainDonate',
        listApiParamSet: {
            nof: 'NoticeFile',
        },
    },
    business: {
        getFunc: 'getBusiness',
        listApiParamSet: {
            type: 'post',
            ip: 1,
            f: 'File',
            obt: 'wr_datetime',
            obs: 'DESC',
        },
        pageRow: 5,
    },
    businessDetail: {
        getFunc: 'getBusiness',
        detailApiParamSet: {
            type: 'post',
        },
    },
    financial: {
        getFunc: 'getFinancial',
        listApiParamSet: {
            type: 'post',
            ip: 1,
            f: 'File',
            obt: 'wr_datetime',
            obs: 'DESC',
        },
        pageRow: 6
    },
    financialDetail: {
        getFunc: 'getFinancial',
        detailApiParamSet: {
            type: 'post',
        },
    },
    news: {
        getFunc: 'getNews',
        listApiParamSet: {
            type: 'post',
            f: 'File',
            ip: 1,
            obt: 'wr_datetime',
            obs: 'DESC',
        },
        pageRow: 5
    },
    newsDetail: {
        getFunc: 'getNews',
        detailApiParamSet: {
            type: 'post',
        },
    },
    donate: {
        getFunc: 'getDonate',
        listApiParamSet: {
            type: 'post',
            ip: 1,
            f: 'File',
            imf: 'ImportantFile',
            obt: 'wr_datetime',
            obs: 'DESC',
        },
        pageRow: 6,
    },
    donateDetail: {
        getFunc: 'getDonate',
        detailApiParamSet: {
            type: 'post',
        },
    },
    primeDonate: {
        getFunc: 'getDonatePrime',
        listApiParamSet: {
            imf: 'ImportantFile',
        },
    },
    primeDonateDetail: {
        getFunc: 'getDonatePrime',
        detailApiParamSet: {
            type: 'post',
        },
    },
    album: {
        getFunc: 'getAlbum',
        listApiParamSet: {
            type: 'post',
            ip: 1,
            f: 'File',
            obt: 'wr_datetime',
            obs: 'DESC',
        },
        pageRow: 6,
    },
    albumDetail: {
        getFunc: 'getAlbum',
        detailApiParamSet: {
            type: 'post',
        },
    },

    newsSearch: {
        getFunc: 'getNews',
        listApiParamSet: {
            type: 'post',
            f: 'File',
            ip: 1,
        },
        pageRow: 5,
    },
    donateSearch: {
        getFunc: 'getDonate',
        listApiParamSet: {
            type: 'post',
            ip: 1,
            f: 'File',
            imf: 'ImportantFile',
        },
        pageRow: 5,
    },
    businessSearch: {
        getFunc: 'getBusiness',
        listApiParamSet: {
            type: 'post',
            ip: 1,
            f: 'File',
        },
        pageRow: 5,
    },
    albumSearch: {
        getFunc: 'getAlbum',
        listApiParamSet: {
            type: 'post',
            ip: 1,
            f: 'File',
        },
        pageRow: 5,
    },
    financialSearch: {
        getFunc: 'getFinancial',
        listApiParamSet: {
            type: 'post',
            ip: 1,
            f: 'File',
        },
        pageRow: 5,
    },
}

export default {
    filterConfig: {
        tab: {
            type: 'match',
            classname: 'tab',
        },
        type: {
            type: 'match',
            classname: 'type',
        },
        su: {
            type: 'query',
            classname: 'filterSearch'
        },
    },
    methods: {
        returnBoardFilterConfig(type) {
            return configBoardFilter[type];
        }
    }
}